import _ from "lodash";

/**
 * Filter keys that narrow the feed. Keep this in sync with the fields
 * LeftpanelTabContent actually writes via updateFilter (propertyType,
 * financeType, timeline, purchaseType, preApproved, bedrooms, beds, baths,
 * sqrftMin/Max, priceMin/Max (see PRICE_RANGE_KEYS), search) - a key here
 * that doesn't match a real filterQuery key silently never counts.
 */
const LIST_FILTER_KEYS = ["propertyType", "financeType", "timeline", "purchaseType"];

// typeOfPlace defaults to every type ([10, 11, 6]) on STR/LTR, so it should
// only count once the agent has actually narrowed it down.
const TYPE_OF_PLACE_DEFAULT = [10, 11, 6];

const SCALAR_FILTER_KEYS = [
  "bedrooms",
  "beds",
  "baths",
  "sqrftMin",
  "sqrftMax",
  "search",
];

// priceMin/priceMax are one dual-handle slider, not two independent filters -
// counted separately they'd read "2" for a single narrowed price range.
const PRICE_RANGE_KEYS = ["priceMin", "priceMax"];

const isEmptyScalar = (v) =>
  v === null || v === undefined || v === "" || v === 0 || v === false;

/**
 * Number of filters actively narrowing the results, for the Sort and Filter
 * badge / empty-state gating.
 */
export function computeActiveFilterCount(filterQuery) {
  const q = filterQuery || {};
  let n = 0;

  LIST_FILTER_KEYS.forEach((k) => {
    const v = _.get(q, k, []);
    if (Array.isArray(v) && v.length > 0) n += 1;
  });

  const typeOfPlace = _.get(q, "typeOfPlace", []);
  if (
    Array.isArray(typeOfPlace) &&
    typeOfPlace.length > 0 &&
    !_.isEqual([...typeOfPlace].sort(), [...TYPE_OF_PLACE_DEFAULT].sort())
  ) {
    n += 1;
  }

  SCALAR_FILTER_KEYS.forEach((k) => {
    const v = _.get(q, k, null);
    if (!isEmptyScalar(v)) n += 1;
  });

  if (PRICE_RANGE_KEYS.some((k) => !isEmptyScalar(_.get(q, k, null)))) {
    n += 1;
  }

  if (q.preApproved) n += 1;

  return n;
}
